import React, { useState, useEffect } from 'react';
import { RiCloseFill } from 'react-icons/ri';
import TagInputs from '../layouts/TagInputs';

import { del, get, post, put } from '../../utility/fetch';
import axios from 'axios';
import notification from '../../utility/notification';
import { usePatient } from '../../contexts';
import { calculateAge, numberWithCommas } from '../../utility/general'

import SpeechToTextButton from "../UI/SpeechToTextButton";
import SuccessModal from './SuccessModal';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from '@mui/material';
import QueueLabWorkModal from './QueueLabWorkModal';
import Spinner from '../UI/Spinner';


const PayWalkInLabRequest = ({ details, labRequest, isQueue, isApproval, getProcedures, patientData, closeModal }) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState(null); // 'approve' or 'decline'
    const [payload, setPayload] = useState({
        firstName: "",
        lastName: "",
        gender: "",
        dateOfBirth: "",
        email: "",
        phoneNumber: "",
    })
    const [labTechs, setLabTechs] = useState([])
    const [loading, setLoading] = useState(false);
    const [selectedServices, setSelectedServices] = useState();
    const [labServices, setLabServices] = useState([]);
    const [view, setView] = useState('reg')
    const [activeId, setActiveId] = useState(0)
    const [active, setActive] = useState(0)
    const [walkInInfo, setWalkInInfo] = useState([])
    const [fade, setFade] = useState("fade-in");
    
    // NEW: State to hold discounts for individual items { [id]: amount }
    const [itemDiscounts, setItemDiscounts] = useState({});

    const isMobile = window.innerWidth < 768;

    const { patientInfo } = usePatient()
    const navigate = useNavigate()

    const openModal = () => {
        setIsModalOpen(true);
    };

    // ... (Existing helper functions like handleServiceChange, approvedCheck, getLabServices, etc. remain unchanged) ...
    
    // ... (Existing submitOrder and submitInternalLabRequest functions remain unchanged) ...

    const approvedCheck = () => {
        if (Array.isArray(patientData?.walkInTestRequests) && patientData.walkInTestRequests.length > 0) {
            const approvals = patientData.walkInTestRequests.map(r => r.isApproved);
            if (approvals.includes(true)) return false;
            else return true;
        }
    }

    const getLabServices = async () => {
        let res = await get(`/internallabservice/list/1/1000`);
        setLabServices(res?.data?.recordList.map((service) => (
            {
                label: service?.name,
                value: service?.id,
                amount: service?.cost,
            }
        )))
    }

    const handleLabTechChange = (event) => {
        setSelectedServices(event?.value);
    };

    const getlabtech = async () => {
        const response = await axios.get(`${process.env.REACT_APP_SERVICES_URL}/profile/profilebyhealthcareproviderid/${sessionStorage?.getItem("clinicId")}`);
        setLabTechs(response.data);
    }

    const submitOrder = async () => {
        setLoading(true);
        try {
            let res = await put(`/walkinlabrequest/${patientData?.id}/pay-cash-for-walk-in-lab-service`,
                {
                    labServices: patientData?.walkInTestRequests?.map((request) => ({
                        walkInTestRequestId: request?.id,
                        amount: request?.cost - request?.discount
                    }))
                }
            );
            if (res.statusCode === 200) {
                notification({ message: res?.data?.message, type: "success" });
                setLoading(false);
                closeModal();
            }
        } catch (error) {
            console.error('Error submitting internal lab request:', error);
            setLoading(false);
        }
    }

    const submitInternalLabRequest = async () => {
        setLoading(true);
        try {
            let res = await post(`/walkinlabrequest`, payload);
            if (res?.statusCode === 200) {
                // getWalkInInfo(res?.data?.walkInLabRequestId)
                openModal();
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        } catch (error) {
            console.error('Error submitting internal lab request:', error);
            setLoading(false);
        }
    }

    // Open confirmation dialog
    const openConfirmDialog = (action) => {
        setConfirmAction(action);
        setConfirmDialogOpen(true);
    };

    // Close confirmation dialog
    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setConfirmAction(null);
    };

    // Execute the action after confirmation
    const handleConfirmApproveOrDecline = async () => {
        closeConfirmDialog();
        await performApproveOrDecline(confirmAction === 'approve');
    };

    // NEW: Handle change for individual discount inputs
    const handleItemDiscountChange = (id, value) => {
        const numValue = parseFloat(value);
        setItemDiscounts(prev => ({
            ...prev,
            [id]: isNaN(numValue) ? 0 : numValue
        }));
    };

    // MODIFIED: Approve/decline helper to use itemDiscounts state
    const performApproveOrDecline = async (approve = true) => {
        if (!patientData || !patientData.walkInTestRequests?.length) {
            notification({ message: 'No queued services to update', type: 'error' });
            return;
        }

        const walkInLabRequestId = patientData?.walkInTestRequests?.[0]?.walkInLabRequestId || patientData?.id;
        
        // Map through requests and apply specific discount from state
        const payloadApprove = {
            approveWalkInTestRequests: patientData.walkInTestRequests.map((r) => ({
                walkInTestRequestId: r.id,
                isApproved: approve,
                discount: itemDiscounts[r.id] || 0 // Use the discount for this specific ID
            }))
        };

        setLoading(true);
        try {
            const res = await put(`/walkinlabrequest/${walkInLabRequestId}/approve-queued-in-lab-services`, payloadApprove);
            if (res?.statusCode === 200 || res?.status === 200) {
                notification({ message: res?.data?.message || 'Operation successful', type: 'success' });
                getProcedures(1);
                closeModal();
            } else {
                console.error('Approve/decline failed', res);
                notification({ message: 'Failed to update approvals', type: 'error' });
            }
        } catch (err) {
            console.error(err);
            notification({ message: 'Failed to update approvals', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleActive = (active) => {
        setActiveId(active?.id);
        setActive(active);
    }

    useEffect(() => {
        getLabServices();
        if (patientData) {
            // Optional: Initialize discounts if data already has them
            const initialDiscounts = {};
            patientData.walkInTestRequests?.forEach(req => {
                if(req.discount) initialDiscounts[req.id] = req.discount;
            });
            setItemDiscounts(initialDiscounts);

            setPayload((prev) => ({
                firstName: patientData.firstName,
                lastName: patientData.lastName,
                gender: patientData?.gender,
                dateOfBirth: patientData?.dateOfBirth,
                email: patientData?.email,
                phoneNumber: patientData?.phoneNumber,
            }));
        }
    }, []);


    // Add delete handler
    const handleDeleteTestRequest = async (walkInTestRequestId) => {
        const ok = window.confirm('Are you sure you want to delete this test request?');
        if (!ok) return;

        setLoading(true);
        try {
            const walkInLabRequestId = patientData?.id;
            const res = await del(
                `/walkinlabrequest/${walkInTestRequestId}/${walkInLabRequestId}/delete-walk-in-test-request`
            );
            if (res?.message || res?.status === 200) {
                notification({ message: 'Test request deleted successfully', type: 'success' });
                closeModal();
            } else {
                notification({ message: 'Failed to delete test request', type: 'error' });
            }
        } catch (err) {
            console.error(err);
            notification({ message: 'Failed to delete test request', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const isApprovedCheck = approvedCheck();

    const renderApprovalStatus = (row) => {
        let value = row?.isApproved;
        if (value === undefined && Array.isArray(row?.walkInTestRequests) && row.walkInTestRequests.length > 0) {
            const approvals = row.walkInTestRequests.map(r => r.isApproved);
            if (approvals.includes(true)) value = true;
            else if (approvals.includes(false)) value = false;
            else value = null;
        }

        const styleBase = { padding: '6px 10px', borderRadius: 6, display: 'inline-block', fontWeight: 700, fontSize: 12 };
        if (value === null || value === undefined) {
            return <td><span style={{ ...styleBase, color: '#555', background: '#f4f4f4' }}>NEW</span></td>;
        }
        if (value === true) {
            return <td><span style={{ ...styleBase, color: '#155724', background: '#d4edda' }}>APPROVED</span></td>;
        }
        return <td><span style={{ ...styleBase, color: '#721c24', background: '#f8d7da' }}>DECLINED</span></td>;
    };

    // Calculate total price minus specific discounts
    const calculateTotal = () => {
        const subtotal = patientData?.walkInTestRequests?.reduce((acc, curr) => acc + (curr?.internalLabService?.cost || 0), 0) || 0;
        const totalDiscount = Object.values(itemDiscounts).reduce((acc, curr) => acc + curr, 0);
        return subtotal - totalDiscount;
    };

     const calculateTotalWithoutDiscounts = () => {
        const subtotal = patientData?.walkInTestRequests?.reduce((acc, curr) => acc + (curr?.internalLabService?.cost || 0), 0) || 0;
        return subtotal;
    };

    return (
        <>
            <div className="modal ">
                <RiCloseFill className='close-btn pointer' onClick={closeModal} />
                <div className={`modal-contents flex flex-direction-v flex-v-center ${fade}`} style={isMobile ? { width: '95%', padding: '10px' } : {}}>
                    <div className="w-100">
                        <div>
                            <h1>Pay Walk-In Lab Request {renderApprovalStatus(patientData)}</h1>
                            <div className='m-t-20'>
                                <h2 className='center-text'>Order Request</h2>
                                <div className="tabs bold-text">
                                    {/* Updated Total Display */}
                                    {<h3 >Original Total Price: {numberWithCommas(calculateTotalWithoutDiscounts())}</h3>}
                                </div>
                                <div className="m-l-40 col-10 cards no-border p-10" style={isMobile ? { marginLeft: 0, width: '100%', padding: 0 } : {}}>
                                    <div className='flex flex-direction-v' style={{gap: '15px'}}>
                                        {
                                            patientData?.walkInTestRequests
                                                ?.filter((test) => (test?.isPaid === false))
                                                ?.map((test, index) => (
                                                    <div key={test?.id} className="flex flex-v-center space-between" style={{ position: 'relative', borderBottom: '1px solid #eee', paddingBottom: '10px', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', gap: isMobile ? '10px' : 0 }}>
                                                        <div onClick={() => handleActive(test)} className={`flex flex-v-center ${'active-key'}`} style={{flex: 1}}>
                                                            <div className="m-r-10 bold-text">{test?.internalLabService?.name}</div>
                                                            <div className="m-r-10 text-grey">({numberWithCommas(test?.internalLabService?.cost)})</div>
                                                        </div>

                                                        {/* NEW: Per-item Discount Input */}
                                                        {isApproval && (
                                                            <div className="flex flex-v-center m-r-20" style={isMobile ? { marginRight: 0, width: '100%' } : {}}>
                                                                <label style={{marginRight: '8px', fontSize: '12px'}}>Discount:</label>
                                                                <input 
                                                                    type="number"
                                                                    min="0"
                                                                    className="form-control"
                                                                    style={{width: '100px', padding: '5px'}}
                                                                    value={itemDiscounts[test.id] || ''}
                                                                    placeholder="0.00"
                                                                    onChange={(e) => handleItemDiscountChange(test.id, e.target.value)}
                                                                />
                                                            </div>
                                                        )}

                                                        {!isQueue && <button
                                                            onClick={() => handleDeleteTestRequest(test?.id)}
                                                            disabled={loading}
                                                            style={{
                                                                background: '#d32f2f',
                                                                color: '#fff',
                                                                border: 'none',
                                                                borderRadius: '50%',
                                                                width: '24px',
                                                                height: '24px',
                                                                padding: 0,
                                                                cursor: 'pointer',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '16px',
                                                                fontWeight: 'bold',
                                                                opacity: loading ? 0.6 : 1
                                                            }}
                                                            title="Delete test request"
                                                        >
                                                            ×
                                                        </button>}
                                                    </div>
                                                ))
                                        }
                                    </div>

                                    <div className="p-10">
                                        <TagInputs label="Amount To Pay" value={numberWithCommas(calculateTotal())} readOnly />

                                        {/* Approve/Decline controls */}
                                        {isApproval ? (
                                            <div style={{ display: 'flex', gap: 8, marginTop: 12, flexDirection: 'column'  }}>
                                                <div style={{ display: 'flex', gap: 8, flexDirection: isMobile ? 'column' : 'row' }}>
                                                    <button
                                                        disabled={loading}
                                                        onClick={() => openConfirmDialog('approve')}
                                                        className="submit-btn"
                                                        style={{ backgroundColor: '#28a745', marginRight: 8, flex: 1 }}
                                                    >
                                                        {loading ? 'Processing...' : 'Approve All'}
                                                    </button>

                                                    <button
                                                        disabled={loading}
                                                        onClick={() => openConfirmDialog('decline')}
                                                        className="submit-btn"
                                                        style={{ backgroundColor: '#d32f2f', flex: 1 }}
                                                    >
                                                        {loading ? 'Processing...' : 'Decline All'}
                                                    </button>
                                                </div>
                                            </div>
                                        ) :
                                            (
                                                <button disabled={loading || isApprovedCheck} onClick={submitOrder} className="submit-btn m-t-20 w-100" style={{ marginTop: isApproval ? 12 : 20 }}>
                                                    {loading ? <span className='flex flex-h-center flex-v-center'>Place order &nbsp; &nbsp; <Spinner width={30} height={30} /></span> : 'Place Order'}
                                                </button>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            {/* Confirmation Modal */}
            {
                confirmDialogOpen && (
                    <div className="modal">
                        <div className={`modal-contents flex flex-direction-v flex-v-center ${fade}`} style={{ maxWidth: '400px' }}>
                            <div style={{ textAlign: 'center' }}>
                                <h2 style={{ marginTop: 0 }}>Confirm Action</h2>
                                <p style={{ color: '#666', marginBottom: 24 }}>
                                    Are you sure you want to <strong>{confirmAction === 'approve' ? 'approve' : 'decline'}</strong> all queued lab services?
                                    {confirmAction === 'approve' && calculateTotal() < (patientData?.walkInTestRequests?.reduce((a,b) => a + (b?.internalLabService?.cost || 0), 0)) && 
                                        <div style={{color: '#ff9800', marginTop: '10px', fontSize: '13px'}}>Note: Discounts will be applied.</div>
                                    }
                                </p>
                                <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
                                    <button
                                        onClick={closeConfirmDialog}
                                        className="submit-btn"
                                        style={{ backgroundColor: '#999', flex: 1 }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleConfirmApproveOrDecline}
                                        disabled={loading}
                                        className="submit-btn"
                                        style={{
                                            backgroundColor: confirmAction === 'approve' ? '#28a745' : '#d32f2f',
                                            flex: 1
                                        }}
                                    >
                                        {loading ? 'Processing...' : (confirmAction === 'approve' ? 'Approve' : 'Decline')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
}

export default PayWalkInLabRequest;